<template>
  <div>
    <printer-order-log v-show="printeractive" ref="printerOrderLog" :sumOfOrders="sumOfOrders" :sumOfExpenses="sumOfExpenses" :getTotalPrice="getTotalPrice"
      :getTotalExpensePrice="getTotalExpensePrice" :reportDate="reportDate" />
    <vs-popup :active.sync="isActive" id="totalOrderLogsPopup" :title="reportTimeRange">
      <vs-row vs-type="flex" vs-w="12" class="total-order-logs-popup-body">
        <vs-row vs-type="flex" vs-w="12">
          <vs-table ref="table" :data="sumOfOrders" class="w-full total-order-logs-table">

            <template slot="thead">

              <vs-th>
                <p>Ödeneme Seçeneği</p>
              </vs-th>
              <vs-th>
                <p>Adet</p>
              </vs-th>
              <vs-th>
                <p>Tutar</p>
              </vs-th>
            </template>

            <template slot-scope="{data}">
              <tbody>
                <vs-tr :data="tr" :key="indextr" v-for="(tr, indextr) in data"
                  :class="{'row-bg-danger' : tr.effect == 'Negatif', 'row-bg-warning' : tr.effect == 'Nötr'}">

                  <vs-td>
                    <p class="font-medium truncate">{{ tr.paymentName }}</p>
                  </vs-td>

                  <vs-td>
                    <p class="font-medium truncate">{{ tr.totalCount }}</p>
                  </vs-td>

                  <vs-td>
                    <p class="font-medium truncate">{{ $toCurrency(tr.totalPrice) }}</p>
                  </vs-td>


                </vs-tr>
                <vs-tr v-if="sumOfExpenses.length > 0" class="row-bg-danger">
                  <vs-td>
                    <p class="font-medium truncate">Gider</p>
                  </vs-td>
                  <vs-td>
                    <p class="font-medium truncate">{{sumOfExpenses.length}}</p>
                  </vs-td>
                  <vs-td>
                    <p class="font-medium truncate">{{$toCurrency(getTotalExpensePrice)}}</p>
                  </vs-td>
                </vs-tr>
              </tbody>
            </template>
          </vs-table>
        </vs-row>
        <vs-row vs-type="flex" vs-w="12" class="mt-2 total-order-logs-footer">
          <vs-col vs-type="block" vs-w="6" vs-justify="flex-start" class="total-order-logs-footer-print">
            <vs-button @click="printOrderLogs" color="primary" icon-pack="feather" icon="icon-printer">
              Yazdır
            </vs-button>
          </vs-col>
          <vs-col vs-type="block" vs-w="6" vs-justify="flex-end" class="total-order-logs-footer-total">
            <div class="total-order-logs-total-line">
              <span class="total-order-logs-total-label">Toplam Net Ciro :</span>
              <span class="total-order-logs-total-value text-primary bold">{{$toCurrency(getTotalPrice)}}</span>
            </div>
          </vs-col>
        </vs-row>
      </vs-row>
    </vs-popup>
  </div>
</template>

<script>
  import PrinterOrderLog from "../OrderLog/TotalOrderLogs/Printer";
  import {
    getSumOfOrdersLive
  } from "@/api/Reports";
  export default {
    data() {
      return {
        isActive: false,
        printeractive: false,
        sumOfOrders: [],
        reportTimeRange:null,
        sumOfExpenses: [],
        filterOptions: {
          endDate: new Date(Date.now()),
          startDate: new Date(Date.now()),
          branchId: "",
          startTime: "00:00",
          endTime: "23:59"
        },
      }
    },
    components: {
      PrinterOrderLog
    },
    watch: {
      isActive(val) {
        if (val) this.saveFilterOptions();
      }
    },
    computed: {
      reportDate(){
       return this.filterOptions.startDate.toString();
      },
      getTotalExpensePrice() {
        return this.sumOfExpenses.reduce(function (total, num) {
          return total + num.price;
        }, 0);
      },
      getTotalPrice() {

        return this.sumOfOrders.reduce(function (total, num) {
          return total + (num.effect == 'Pozitif' ? num.totalPrice : 0);
        }, 0);
      },
    },
    methods: {
      printOrderLogs() {
        this.printeractive = true;
        this.$nextTick(() => {
  this.$refs.printerOrderLog.printTotalOrderLogs();
});
      },
      saveFilterOptions() {
        getSumOfOrdersLive().then(res => {
          if (res && res.status == 200) {
            this.sumOfOrders = res.data.paymentReport;
            this.sumOfExpenses = res.data.sumOfExpenses;
            this.reportTimeRange = res.data.timeRange;
          } else {
            this.$fire({
              title: "Hata : " + res.status,
              text: "Rapor Hazırlanamadı !",
              type: "error"
            });
            this.$vs.notify({
              color: "danger",
              title: "Hata : " + res.status,
              text: "Rapor Hazırlanamadı !"
            });
          }
        }).catch(() => {
          this.$fire({
            title: "Hata !",
              text: "Rapor Hazırlanamadı !",
              type: "error"
            });
          this.$vs.notify({
            color: "danger",
            title: "Hata !",
            text: "Sunucu Bağlantı Hatası !"
          });
        });
      },
    }
  }

</script>

<style>
  .row-bg-danger {
    background-color: rgba(238, 66, 75, 0.5) !important;
  }

  .row-bg-warning {
    background-color: rgba(255, 159, 67, .5) !important;
  }

  .swal2-container {
    z-index: 99999;
  }

  /* Mobil: popup + tablo viewport genişliğinde, yatay kaydırma yok */
  #totalOrderLogsPopup .vs-popup {
    max-width: calc(100vw - 1rem) !important;
    width: calc(100vw - 1rem) !important;
    box-sizing: border-box;
  }

  @media (min-width: 520px) {
    #totalOrderLogsPopup .vs-popup {
      width: auto !important;
      max-width: min(36rem, calc(100vw - 2rem)) !important;
    }
  }

  #totalOrderLogsPopup .vs-popup--header h3 {
    font-size: clamp(0.8rem, 3.5vw, 1rem);
    line-height: 1.25;
    word-break: break-word;
  }

  #totalOrderLogsPopup .total-order-logs-popup-body {
    max-width: 100%;
    box-sizing: border-box;
  }

  #totalOrderLogsPopup .vs-popup--content {
    max-width: 100%;
    overflow-x: hidden !important;
    box-sizing: border-box;
    padding-left: 0.5rem !important;
    padding-right: 0.5rem !important;
  }

  #totalOrderLogsPopup .con-tablex.vs-table--content {
    max-width: 100%;
    overflow-x: hidden !important;
  }

  #totalOrderLogsPopup .vs-con-tbody.vs-table--tbody {
    overflow-x: hidden !important;
    max-width: 100%;
  }

  #totalOrderLogsPopup .vs-table.vs-table--tbody-table {
    table-layout: fixed !important;
    width: 100% !important;
    max-width: 100%;
  }

  #totalOrderLogsPopup .vs-table--tbody-table th,
  #totalOrderLogsPopup .vs-table--tbody-table td {
    word-break: break-word;
    overflow-wrap: anywhere;
    padding: 0.45rem 0.35rem !important;
    vertical-align: middle;
  }

  #totalOrderLogsPopup .vs-table--tbody-table th:nth-child(1),
  #totalOrderLogsPopup .vs-table--tbody-table td:nth-child(1) {
    width: 44%;
  }

  #totalOrderLogsPopup .vs-table--tbody-table th:nth-child(2),
  #totalOrderLogsPopup .vs-table--tbody-table td:nth-child(2) {
    width: 20%;
    text-align: center;
  }

  #totalOrderLogsPopup .vs-table--tbody-table th:nth-child(3),
  #totalOrderLogsPopup .vs-table--tbody-table td:nth-child(3) {
    width: 36%;
    text-align: right;
  }

  #totalOrderLogsPopup .vs-table-text p {
    margin: 0;
    font-size: clamp(0.72rem, 3.2vw, 0.9rem);
    line-height: 1.2;
  }

  #totalOrderLogsPopup .total-order-logs-footer {
    flex-wrap: wrap !important;
    align-items: center;
    gap: 0.5rem;
  }

  #totalOrderLogsPopup .total-order-logs-footer-print,
  #totalOrderLogsPopup .total-order-logs-footer-total {
    min-width: 0;
  }

  @media (max-width: 519px) {
    #totalOrderLogsPopup .total-order-logs-footer-print.vs-col,
    #totalOrderLogsPopup .total-order-logs-footer-total.vs-col {
      width: 100% !important;
      max-width: 100% !important;
    }

    #totalOrderLogsPopup .total-order-logs-total-line {
      justify-content: flex-start;
    }
  }

  #totalOrderLogsPopup .total-order-logs-total-line {
    display: flex;
    flex-wrap: wrap;
    align-items: baseline;
    gap: 0.35rem 0.5rem;
    justify-content: flex-end;
    max-width: 100%;
  }

  #totalOrderLogsPopup .total-order-logs-total-label {
    font-size: clamp(0.75rem, 3.2vw, 0.95rem);
  }

  #totalOrderLogsPopup .total-order-logs-total-value {
    font-size: clamp(0.85rem, 3.6vw, 1.1rem);
  }
</style>
